import { RelationSourceType } from '@lib/company-content-relations';
import { withStyles, Theme, Chip, Tooltip } from '@material-ui/core';
import React from 'react';
import { indigo, pink, yellow } from '@material-ui/core/colors';
import { generateChipColor } from '@lib/common';
import {
  GiArtificialHive,
  SiMicrosoftexcel,
  MdKeyboard,
  VscMultipleWindows,
} from '@icon/react-icons';
import { C2PRelationSourceType } from '@pages/company-to-person/company-person-relation.enums';

type RelationSourceChipIconProps = React.ComponentProps<typeof Chip> & {
  type: RelationSourceType | `${RelationSourceType}` | C2PRelationSourceType;
  iconOnly?: boolean;
};

const relationMap = {
  [RelationSourceType.OMDB]: {
    color: pink,
    label: 'OMDB',
    icon: <SiMicrosoftexcel style={{ color: 'inherit' }} />,
  },
  [RelationSourceType.Client]: {
    color: pink,
    label: 'Client',
    icon: <SiMicrosoftexcel style={{ color: 'inherit' }} />,
  },
  [RelationSourceType.DELI]: {
    color: yellow,
    label: 'Deli',
    icon: <MdKeyboard style={{ color: 'inherit' }} />,
  },
  [RelationSourceType.SelfService]: {
    color: indigo,
    label: 'Self Service',
    icon: <GiArtificialHive />,
  },
  [RelationSourceType.DealIntel]: {
    color: pink,
    label: 'DealIntel',
    icon: <VscMultipleWindows />,
  },
  unknown: {
    color: pink,
    label: 'unknown',
    icon: <SiMicrosoftexcel style={{ color: 'inherit' }} />,
  },
};

export const RelationSourceChip = withStyles<string, {}, RelationSourceChipIconProps>(
  (theme: Theme) => ({
    root: ({ type }) => generateChipColor(theme, (relationMap[type] || relationMap.unknown).color),
    label: ({ iconOnly }) => (iconOnly ? { paddingLeft: 0 } : {}),
  })
)(({ type, children, iconOnly, ...props }: RelationSourceChipIconProps) => {
  const map = relationMap[type] || relationMap.unknown;
  return (
    <Tooltip title={`Source:  ${type}`}>
      {map.label != 'unknown' ? (
        <Chip color="secondary" icon={map.icon} label={iconOnly ? null : map.label} {...props} />
      ) : (
        <Chip color="secondary" label={iconOnly ? null : type} {...props} />
      )}
    </Tooltip>
  );
});
